(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 4, initialState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        this.size = size;
        this.score = 0;
        this.board = initialState || this.createEmptyBoard();
        this.status = "idle";
        this.tr = document.querySelectorAll(".game-field tbody tr");
        this.assignIdToCell();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "sideMovement",
            value: function sideMovement(e) {
                if (this.status !== "playing") return;
                var oldBoard = this.board.map(function(row) {
                    return row.slice();
                });
                switch(e.code){
                    case "ArrowLeft":
                        this.moveLeft();
                        break;
                    case "ArrowRight":
                        this.moveRight();
                        break;
                    case "ArrowUp":
                        this.moveUp();
                        break;
                    case "ArrowDown":
                        this.moveDown();
                        break;
                    default:
                        return;
                }
                if (this.isNewBoard(oldBoard, this.board)) {
                    this.setTwo();
                    this.checkLose();
                    this.checkWin();
                }
            }
        },
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var _this = this;
                return Array(this.size).fill(0).map(function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "slideZero",
            value: function slideZero(row) {
                return row.filter(function(num) {
                    return num !== 0;
                });
            }
        },
        {
            key: "slide",
            value: function slide(row) {
                var newRow = this.slideZero(row);
                for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                    newRow[i] = newRow[i] * 2;
                    this.score += newRow[i];
                    newRow[i + 1] = 0;
                }
                newRow = this.slideZero(newRow);
                while(newRow.length !== this.size)newRow.push(0);
                return newRow;
            }
        },
        {
            key: "setTwo",
            value: function setTwo() {
                if (!this.hasEmptyTile()) return;
                var found = false;
                while(!found){
                    var r = Math.floor(Math.random() * this.size);
                    var c = Math.floor(Math.random() * this.size);
                    if (this.board[r][c] === 0) {
                        this.board[r][c] = Math.random() < 0.9 ? 2 : 4;
                        found = true;
                    }
                }
            }
        },
        {
            key: "hasEmptyTile",
            value: function hasEmptyTile() {
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++){
                    if (this.board[r][c] === 0) return true;
                }
                return false;
            }
        },
        {
            key: "assignIdToCell",
            value: function assignIdToCell() {
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++){
                    var cell = this.tr[r].children[c];
                    cell.id = r + "-" + c;
                }
            }
        },
        {
            key: "showMessage",
            value: function showMessage(type) {
                var messages = [
                    "message-start",
                    "message-lose",
                    "message-win"
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var msg = _step.value;
                        var element = document.querySelector(".message.".concat(msg));
                        if (!element) continue;
                        if (msg === type) element.classList.remove("hidden");
                        else element.classList.add("hidden");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var r = 0; r < this.size; r++){
                    for(var c = 0; c < this.size; c++)if (this.board[r][c] === 2048) {
                        this.status = "win";
                        this.showMessage("message-win");
                        return;
                    }
                }
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++){
                    var cell = this.board[r][c];
                    if (cell === 0) return false;
                    if (c < this.size - 1 && cell === this.board[r][c + 1]) return false;
                    if (r < this.size - 1 && cell === this.board[r + 1][c]) return false;
                }
                this.status = "lose";
                this.showMessage("message-lose");
            }
        },
        {
            key: "isNewBoard",
            value: function isNewBoard(oldBoard, newBoard) {
                return JSON.stringify(oldBoard) !== JSON.stringify(newBoard);
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                for(var r = 0; r < this.size; r++){
                    var row = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[r]);
                    row = this.slide(row);
                    this.board[r] = row;
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                for(var r = 0; r < this.size; r++){
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[r]).reverse();
                    reversedRow = this.slide(reversedRow);
                    this.board[r] = reversedRow.reverse();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                for(var c = 0; c < this.size; c++){
                    var col = [];
                    for(var r = 0; r < this.size; r++)col.push(this.board[r][c]);
                    col = this.slide(col);
                    for(var r1 = 0; r1 < this.size; r1++)this.board[r1][c] = col[r1];
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                for(var c = 0; c < this.size; c++){
                    var col = [];
                    for(var r = this.size - 1; r >= 0; r--)col.push(this.board[r][c]);
                    col = this.slide(col);
                    for(var r1 = 0; r1 < this.size; r1++)this.board[this.size - 1 - r1][c] = col[r1];
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.score = 0;
                this.status = "playing";
                this.board = this.createEmptyBoard();
                this.setTwo();
                this.setTwo();
                var button = document.querySelector("button.start, button.restart");
                button.classList.remove("start");
                button.classList.add("restart");
                button.innerText = "Restart";
                this.showMessage(null);
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = "idle";
                this.board = this.createEmptyBoard();
                this.showMessage = "message-start";
                var button = document.querySelector("button.start, button.restart");
                button.classList.remove("restart");
                button.classList.add("start");
                button.innerText = "Start";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
function $197cd56b15c33885$var$updateScoreUI() {
    document.querySelector(".game-score").innerText = $197cd56b15c33885$var$game.score;
}
function $197cd56b15c33885$var$updateCell(cell, num) {
    cell.className = "field-cell";
    if (num > 0) {
        cell.classList.add("field-cell--".concat(num));
        cell.innerText = num;
    } else cell.innerText = "";
}
function $197cd56b15c33885$var$updateBoard() {
    for(var r = 0; r < $197cd56b15c33885$var$game.size; r++)for(var c = 0; c < $197cd56b15c33885$var$game.size; c++){
        var cell = $197cd56b15c33885$var$game.tr[r].children[c];
        var num = $197cd56b15c33885$var$game.board[r][c];
        $197cd56b15c33885$var$updateCell(cell, num);
    }
    $197cd56b15c33885$var$updateScoreUI();
}
document.querySelector("button.start, button.restart").addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.status === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$updateBoard();
});
document.addEventListener("keyup", function(e) {
    $197cd56b15c33885$var$game.sideMovement(e);
    $197cd56b15c33885$var$updateBoard();
});

})();
//# sourceMappingURL=index.812b3793.js.map
